<template>
  <div>
    <b-modal
      id="secure-docs-modal"
      ref="secure-docs-modal-ref"
      hide-footer
      title="Secure Document Portal"
    >
      <!-- Service down alerts -->
      <b-alert v-if="serviceDown" variant="danger" show>
        <b-card-text class="text-center">
          <p>Sorry it looks like the service is down.</p>
          <p>
            Please contact one of our Travel Centres if the problem persists.
          </p>
        </b-card-text>
      </b-alert>
      <!-- No Data Alert - most likely been deleted and SF doesn't update -->
      <b-alert v-if="showNoDocumentsMsg" class="no-docs" show>
        <b-card-text class="text-center">
          <p>There are currently no required documents to upload</p>
        </b-card-text>
      </b-alert>

      <!-- If service is up and running -->
      <div v-if="!serviceDown">
        <!-- Upload error and success messages -->
        <b-alert variant="danger" v-if="showError" show id="uploaderror">
          <b-card-text>
            <strong>Alert!</strong> your record update has failed. Please re-try
            or contact us for assistance.
          </b-card-text>
        </b-alert>
        <b-alert v-if="showSuccess" variant="success" show id="uploadsuccess">
          <b-card-text>
            <strong>Success!</strong> your records have been successfully
            updated.
          </b-card-text>
        </b-alert>
        <!-- End of error / success messages -->
        <!-- First section -->
        <h4 v-if="modalData.formsPerGroup.length > 0">
          Form(s) Per Group / Family
        </h4>
        <div
          v-if="modalData.formsPerGroup.length > 0"
          class="secure-doc-grid-1"
        >
          <!-- Will be hidden on mobile -->
          <div class="secure-doc-grid-1-row-1">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>Deadline Date</div>
          </div>
          <!-- Loop through form data and output to UI -->
          <div v-for="(form, index) in modalData.formsPerGroup" :key="index">
            <div class="secure-doc-grid-1-row-2">
              <!-- Column 1 -->
              <div class="secure-doc-icon">
                <b-img
                  v-if="form.completed === true"
                  src="https://cdn.trailfinders.com/e0mub0jwe0_approve.png"
                  fluid
                  class="icon-img"
                  alt="secure-doc-completed"
                >
                </b-img>
                <b-img
                  v-if="form.completed === false"
                  src="https://cdn.trailfinders.com/bwflpbt1xz_rejected.png"
                  fluid
                  class="icon-img"
                  alt="secure-doc-notcompleted"
                >
                </b-img>
                <h5>
                  <strong>{{ form.vt_value }}</strong>
                </h5>
                <span
                  v-if="form.client_hint"
                  class="material-icons"
                  :title="form.client_hint"
                  :id="`tooltip-target-a${index}`"
                  >contact_support
                </span>
                <b-tooltip :target="`tooltip-target-a${index}`" triggers="hover">
                  {{ form.client_hint }}
                </b-tooltip>
              </div>
              <!-- Column 2 -->
              <div class="secure-doc-options">
                <!-- if doc is === weburl -->
                <div class="option-btns" v-if="form.document === 'weburl'">
                  <div>
                    <b-button
                      @click="openWebsite(form.vt_value, form.supplier_ref)"
                      variant="primary"
                      class="btn-secure justify-content-center"
                    >
                      Form
                    </b-button>
                  </div>
                  <div>
                    <!-- TODO To change to single button -->
                    <b-button
                      v-if="!form.completed_date"
                      @click="
                        modalData.supplier_ref
                          ? completeSupplierFilePerGroup(form.vt_value, index)
                          : completeAdhocFilePerGroup(form.vt_value, index)
                      "
                      variant="success"
                      class="justify-content-center btn-secure"
                      >Click to Confirm</b-button
                    >
                    <b-button
                      v-if="form.completed"
                      variant="outline-primary"
                      class="justify-content-center btn-secure btn-secure-complete"
                      :disabled="form.completed === true"
                      >Click to Confirm</b-button
                    >
                  </div>
                </div>
                <!-- if doc is !== weburl -->
                <div class="option-btns" v-if="form.document !== 'weburl'">
                  <div>
                    <!-- Display relevent form button -->
                    <a
                      v-if="
                        form.document === 'document' &&
                        form.type === 'download' &&
                        modalData.supplier_ref
                      "
                      :href="
                        api +
                        '/get-supplier-file/' +
                        form.vt_value +
                        '/' +
                        modalData.supplier_ref
                      "
                      target="_blank"
                    >
                      <b-button
                        variant="primary"
                        class="justify-content-center btn-secure"
                      >
                        Form
                      </b-button>
                    </a>
                    <a
                      v-if="
                        form.document === 'document' &&
                        form.type === 'download' &&
                        !modalData.supplier_ref
                      "
                      :href="api + '/get-adhoc-file/' + form.vt_value"
                      target="_blank"
                    >
                      <b-button
                        variant="primary"
                        class="justify-content-center btn-secure"
                      >
                        Form
                      </b-button>
                    </a>
                    <b-button
                      v-if="
                        form.document === 'weburlDownload' &&
                        form.type === 'download'
                      "
                      @click="
                        openWebsite(form.vt_value, modalData.supplier_ref)
                      "
                      variant="primary"
                      class="justify-content-center btn-secure"
                    >
                      Form
                    </b-button>
                  </div>
                  <!-- Choose file btns -->
                  <div>
                    <div
                      class="justify-content-center btn-secure btn-secure-upload"
                    >
                      <input
                        id="upload"
                        type="file"
                        hidden
                        ref="fileGroup"
                        @change="uploadFile('fileGroup')"
                        accept="image/*,.pdf,.doc,.docx,.pptx,.csv"
                      />
                      <label
                        class="justify-content-center btn-secure"
                        for="upload"
                      >
                        <span v-if="!fileObject.fileGroup">Choose File</span>
                        <span v-if="fileObject.fileGroup">File Chosen</span>
                      </label>
                    </div>
                  </div>
                  <!-- Upload file btn -->
                  <!-- Supplier -->
                  <div v-if="modalData.supplier_ref">
                    <b-button
                      :disabled="!fileObject.fileGroup"
                      :class="{
                        'btn-success': fileObject.fileGroup,
                        'btn-outline-secondary': !fileObject.fileGroup,
                      }"
                      class="justify-content-center btn-secure"
                      @click="
                        uploadSupplierFilePerGroup(
                          fileObject.fileGroup,
                          form.vt_value,
                          index
                        )
                      "
                    >
                      <span v-if="form.completed === false">Upload</span>
                      <span v-if="form.completed === true">Resend</span>
                    </b-button>
                  </div>
                  <!-- Adhoc -->
                  <div v-if="!modalData.supplier_ref">
                    <b-button
                      :disabled="!fileObject.fileGroup"
                      :class="{
                        'btn-success': fileObject.fileGroup,
                        'btn-outline-secondary': !fileObject.fileGroup,
                      }"
                      class="justify-content-center btn-secure"
                      @click="
                        uploadAdhocFilePerGroup(
                          fileObject.fileGroup,
                          form.vt_value,
                          index
                        )
                      "
                    >
                      <span v-if="form.completed === false">Upload</span>
                      <span v-if="form.completed === true">Resend</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- Column 3 -->
              <div
                :style="{
                  color:
                    form.passedDeadline === true && form.completed === false
                      ? 'red'
                      : 'black',
                }"
                class="secure-deadline"
              >
                <strong v-if="form.completed === false">
                  <span class="deadline-date-span">Deadline Date:</span>
                  {{ form.deadlineDate }}
                </strong>
                <strong v-if="form.completed === true">Completed</strong>
              </div>
            </div>
            <hr class="hr-mobile-only" />
          </div>
        </div>
        <!-- Second section -->
        <h4 v-if="modalData.formsPerPerson.length > 0">Form(s) Per Person</h4>
        <div v-if="showTable && modalData.formsPerPerson.length > 0">
          <div
            v-for="(form, parentIndex) in modalData.formsPerPerson"
            :key="parentIndex"
          >
            <!-- Medical or fitness form -->
            <div>
              <div class="upload-doc">
                <b-img
                  src="https://cdn.trailfinders.com/mbgdeca75n_right_arrow.png"
                  fluid
                  class="icon-img"
                  alt="secure-doc-right-arrow"
                >
                </b-img>
                <h5>
                  <strong>{{ form.vt_value }}</strong>
                </h5>
                <span
                  v-if="form.client_hint"
                  class="material-icons"
                  :title="form.client_hint"
                  :id="`tooltip-target-b${parentIndex}`"
                  >contact_support
                </span>
                <b-tooltip :target="`tooltip-target-b${parentIndex}`" triggers="hover">
                  {{ form.client_hint }}
                </b-tooltip>
              </div>
              <!-- Will be hidden on mobile -->
              <div class="secure-doc-grid-1-row-1">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div>Deadline Date</div>
              </div>
            </div>
            <!-- Row -->
            <div v-for="(client, childIndex) in form.clients" :key="childIndex">
              <div class="secure-doc-grid-1-row-2">
                <!-- Column 1 -->
                <div class="secure-doc-icon">
                  <b-img
                    v-if="client.completed === true"
                    src="https://cdn.trailfinders.com/e0mub0jwe0_approve.png"
                    fluid
                    class="icon-img"
                    alt="secure-doc-completed"
                  >
                  </b-img>
                  <b-img
                    v-if="client.completed === false"
                    src="https://cdn.trailfinders.com/bwflpbt1xz_rejected.png"
                    fluid
                    class="icon-img"
                    alt="secure-doc-notcompleted"
                  >
                  </b-img>
                  <h5>
                    <strong>{{ client.name }}</strong>
                  </h5>
                </div>
                <!-- Column 2 -->
                <div>
                  <!-- if document === weburl -->
                  <div
                    v-if="form.document && form.document === 'weburl'"
                    class="option-btns"
                  >
                    <div>
                      <b-button
                        variant="primary"
                        class="justify-content-center btn-secure"
                        @click="
                          openWebsite(form.vt_value, modalData.supplier_ref)
                        "
                      >
                        Form
                      </b-button>
                    </div>
                    <div v-if="modalData.supplier_ref">
                      <b-button
                        :class="{
                          'btn-success': !client.completed_date,
                          'btn-outline-secondary': client.completed === true,
                        }"
                        :disabled="client.completed === true"
                        class="justify-content-center btn-secure"
                        @click="
                          completeSupplierFilePerPerson(
                            form.vt_value,
                            client.name,
                            parentIndex,
                            childIndex
                          )
                        "
                      >
                        Click to Confirm
                      </b-button>
                    </div>
                    <div v-if="!modalData.supplier_ref">
                      <b-button
                        :class="{
                          'btn-success': !client.completed_date,
                          'btn-outline-secondary': client.completed === true,
                        }"
                        :disabled="client.completed === true"
                        class="justify-content-center btn-secure"
                        @click="
                          completeAdhocFilePerPerson(
                            form.vt_value,
                            client.name,
                            parentIndex,
                            childIndex
                          )
                        "
                      >
                        Click to Confirm
                      </b-button>
                    </div>
                  </div>
                  <!-- if document !== to weburl -->
                  <div
                    v-if="
                      (form.document && form.document !== 'weburl') ||
                      form.type === 'no_download'
                    "
                    class="option-btns"
                  >
                    <!-- Display relevent form btns -->
                    <div v-if="form.type === 'download'">
                      <a
                        v-if="
                          form.document === 'document' &&
                          form.type === 'download' &&
                          modalData.supplier_ref
                        "
                        :href="
                          api +
                          '/get-supplier-file/' +
                          form.vt_value +
                          '/' +
                          modalData.supplier_ref
                        "
                        target="_blank"
                      >
                        <b-button
                          variant="primary"
                          class="justify-content-center btn-secure"
                        >
                          Form
                        </b-button>
                      </a>
                      <a
                        v-if="
                          form.document === 'document' &&
                          form.type === 'download' &&
                          !modalData.supplier_ref
                        "
                        :href="api + '/get-adhoc-file/' + form.vt_value"
                        target="_blank"
                      >
                        <b-button
                          variant="primary"
                          class="justify-content-center btn-secure"
                        >
                          Form
                        </b-button>
                      </a>
                      <b-button
                        v-if="
                          form.document === 'weburlDownload' &&
                          form.type === 'download'
                        "
                        @click="
                          openWebsite(form.vt_value, modalData.supplier_ref)
                        "
                        variant="primary"
                        class="justify-content-center btn-secure"
                      >
                        Form
                      </b-button>
                    </div>
                    <!-- Display choose file btn -->
                    <div>
                      <div
                        class="justify-content-center btn-secure btn-secure-upload"
                      >
                        <input
                          :id="trimValue(form.vt_value) + '-' + childIndex"
                          type="file"
                          hidden
                          :ref="trimValue(form.vt_value) + '-' + childIndex"
                          @change="
                            uploadFile(
                              trimValue(form.vt_value) + '-' + childIndex
                            )
                          "
                          accept="image/*,.pdf,.doc,.docx,.pptx,.csv"
                        />
                        <label
                          class="justify-content-center btn-secure"
                          :for="trimValue(form.vt_value) + '-' + childIndex"
                        >
                          <span
                            v-if="
                              !fileObject[
                                trimValue(form.vt_value) + '-' + childIndex
                              ]
                            "
                            >Choose File</span
                          >
                          <span
                            v-if="
                              fileObject[
                                trimValue(form.vt_value) + '-' + childIndex
                              ]
                            "
                            >File Chosen</span
                          >
                        </label>
                      </div>
                    </div>
                    <!-- Display upload file btn -->
                    <!-- Supplier -->
                    <div v-if="modalData.supplier_ref">
                      <b-button
                        :disabled="
                          !fileObject[
                            trimValue(form.vt_value) + '-' + childIndex
                          ]
                        "
                        :class="{
                          'btn-success':
                            fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                          'btn-outline-secondary':
                            !fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                        }"
                        class="justify-content-center btn-secure"
                        @click="
                          uploadSupplierFilePerPerson(
                            fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                            form.vt_value,
                            client.name,
                            parentIndex,
                            childIndex
                          )
                        "
                      >
                        <span v-if="client.completed === false">Upload</span>
                        <span v-if="client.completed === true">Resend</span>
                      </b-button>
                    </div>
                    <!-- Adhoc -->
                    <div v-if="!modalData.supplier_ref">
                      <b-button
                        :disabled="
                          !fileObject[
                            trimValue(form.vt_value) + '-' + childIndex
                          ]
                        "
                        :class="{
                          'btn-success':
                            fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                          'btn-outline-secondary':
                            !fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                        }"
                        class="justify-content-center btn-secure"
                        @click="
                          uploadAdhocFilePerPerson(
                            fileObject[
                              trimValue(form.vt_value) + '-' + childIndex
                            ],
                            form.vt_value,
                            client.name,
                            parentIndex,
                            childIndex
                          )
                        "
                      >
                        <span v-if="client.completed === false">Upload</span>
                        <span v-if="client.completed === true">Resend</span>
                      </b-button>
                    </div>
                  </div>
                  <div>
                    <b-button
                      v-if="form.type === 'insurance'"
                      variant="primary"
                      @click="openInsuranceForm(form.vt_value, client.name)"
                      class="btn-secure justify-content-center"
                    >
                      {{
                        !client.completed
                          ? "Click to Enter Details"
                          : "Click to Edit Details"
                      }}
                    </b-button>
                    <b-button
                      v-if="form.type === 'next_of_kin'"
                      variant="primary"
                      @click="openNextofKinForm(form.vt_value, client.name)"
                      class="btn-secure justify-content-center"
                    >
                      {{
                        !client.completed
                          ? "Click to Enter Details"
                          : "Click to Edit Details"
                      }}
                    </b-button>
                    <b-button
                      v-if="form.type === 'emergency_details'"
                      variant="primary"
                      @click="openEmergencyForm(form.vt_value, client.name)"
                      class="btn-secure justify-content-center"
                    >
                      {{
                        !client.completed
                          ? "Click to Enter Details"
                          : "Click to Edit Details"
                      }}
                    </b-button>
                  </div>
                </div>
                <!-- Column 3 -->
                <div
                  :style="{
                    color:
                      form.passedDeadline === true && client.completed === false
                        ? 'red'
                        : 'black',
                  }"
                  class="secure-deadline"
                >
                  <strong v-if="client.completed === false">
                    <span class="deadline-date-span">Deadline Date:</span>
                    {{ form.deadlineDate }}
                  </strong>
                  <strong v-if="client.completed === true">Completed</strong>
                </div>
                <hr class="hr-mobile-only" />
              </div>
            </div>
          </div>
        </div>
        <!-- Insurance Form -->
        <form
          v-if="!showTable && showInsurance"
          name="insuranceForm"
          id="insuranceForm"
          class="row secure-doc-insurance justify-content-center"
        >
          <div class="col-10 col-lg-6">
            <h6>
              <strong>Insurance details for: {{ clientName }}</strong>
            </h6>
            <!-- Name of Insurer -->
            <div class="form-group">
              <label for="insuranceName">Name of Insurer *</label>
              <input
                type="text"
                id="insuranceName"
                class="form-control"
                v-model="$v.insurance.name.$model"
                required
              />
              <div
                class="help-block"
                v-show="$v.insurance.name.$dirty && !$v.insurance.name.required"
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Policy Number -->
            <div class="form-group">
              <label for="insurancePolicyNum">Insurance Policy Number *</label>
              <input
                type="text"
                id="insurancePolicyNum"
                class="form-control"
                v-model="$v.insurance.policyNumber.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.insurance.policyNumber.$dirty &&
                  !$v.insurance.policyNumber.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Insurance emergency contact -->
            <div class="form-group">
              <label for="insuranceContactNumber"
                >Insurance Emergency Contact Number *</label
              >
              <input
                type="number"
                id="insuranceContactNumber"
                class="form-control"
                v-model="$v.insurance.number.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.insurance.number.$dirty && !$v.insurance.number.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Submit -->
            <div class="row">
              <div class="col-6">
                <b-button
                  variant="primary"
                  class="justify-content-center btn-secure"
                  @click.prevent="submitInsuranceForm"
                >
                  Submit
                </b-button>
              </div>
              <div class="col-6">
                <b-button
                  variant="danger"
                  class="justify-content-center btn-secure"
                  @click.prevent="returnFromForm"
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>
        </form>
        <!-- Next of Kin Form -->
        <form
          v-if="!showTable && showNextOfKin"
          name="nextOfKinForm"
          id="nextOfKinForm"
          class="row secure-doc-nextkin justify-content-center"
        >
          <div class="col-10 col-lg-6">
            <h6>
              <strong>Next of kin details for: {{ clientName }}</strong>
            </h6>
            <!-- Name of next of kin -->
            <div class="form-group">
              <label for="nextOfKinName">Name *</label>
              <input
                type="text"
                id="nextOfKinName"
                class="form-control"
                v-model="$v.nextOfKin.name.$model"
                required
              />
              <div
                class="help-block"
                v-show="$v.nextOfKin.name.$dirty && !$v.nextOfKin.name.required"
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Relationship -->
            <div class="form-group">
              <label for="nextOfKinRelationship"
                >Relationship to Person *</label
              >
              <input
                type="text"
                id="nextOfKinRelationship"
                class="form-control"
                v-model="$v.nextOfKin.relationship.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.nextOfKin.relationship.$dirty &&
                  !$v.nextOfKin.relationship.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Phone number -->
            <div class="form-group">
              <label for="nextOfKinNumber">Phone Number *</label>
              <input
                type="number"
                id="nextOfKinNumber"
                class="form-control"
                v-model="$v.nextOfKin.number.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.nextOfKin.number.$dirty && !$v.nextOfKin.number.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Submit -->
            <div class="row">
              <div class="col-6">
                <b-button
                  variant="primary"
                  class="justify-content-center btn-secure"
                  @click.prevent="submitNextofKinForm"
                >
                  Submit
                </b-button>
              </div>
              <div class="col-6">
                <b-button
                  variant="danger"
                  class="justify-content-center btn-secure"
                  @click.prevent="returnFromForm"
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>
        </form>
        <!-- Emergency contact form -->
        <form
          v-if="!showTable && showEmergencyDetails"
          name="emergencyForm"
          id="emergencyForm"
          class="row secure-doc-emergency justify-content-center"
        >
          <div class="col-10 col-lg-6">
            <h6>
              <strong>Emergency contact details for: {{ clientName }}</strong>
            </h6>
            <!-- Emergency contact email -->
            <div class="form-group">
              <label for="emergencyEmail">Email *</label>
              <input
                type="text"
                id="emergencyEmail"
                class="form-control"
                v-model="$v.emergencyDetails.email.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.emergencyDetails.email.$dirty &&
                  !$v.emergencyDetails.email.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Number -->
            <div class="form-group">
              <label for="emergencyNumber">Emergency Number *</label>
              <input
                type="number"
                id="emergencyNumber"
                class="form-control"
                v-model="$v.emergencyDetails.number.$model"
                required
              />
              <div
                class="help-block"
                v-show="
                  $v.emergencyDetails.number.$dirty &&
                  !$v.emergencyDetails.number.required
                "
              >
                <span>Please fill in this field</span>
              </div>
            </div>
            <!-- Submit -->
            <div class="row">
              <div class="col-6">
                <b-button
                  variant="primary"
                  class="justify-content-center btn-secure"
                  @click.prevent="submitEmergencyForm"
                >
                  Submit
                </b-button>
              </div>
              <div class="col-6">
                <b-button
                  variant="danger"
                  class="justify-content-center btn-secure"
                  @click.prevent="returnFromForm"
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  fetchAdhocDocuments,
  fetchSupplierProgress,
  completeSupplierFilePerGroupService,
  fetchSupplierWebURL,
  fetchAdhocWebURL,
  completeAdhocFilePerGroupService,
  uploadAdhocFilePerGroupService,
  uploadSupplierFilePerGroupService,
  completeSupplierFilePerPersonService,
  completeAdhocFilePerPersonService,
  uploadSupplierFilePerPersonService,
  uploadAdhocFilePerPersonService,
  updateSecureDetails,
} from "./services";
import { required } from "vuelidate/lib/validators";
const { VUE_APP_VT_DOCS } = process.env;
export default {
  props: ["info"],
  computed: {
    ...mapGetters({ getUserData: "auth/getUserData" }),
    fileObject() {
      return this.file;
    },
  },
  data() {
    return {
      serviceDown: null,
      showError: null,
      showSuccess: null,
      showNoDocumentsMsg: false,
      showTable: true,
      clientName: "",
      showInsurance: false,
      showNextOfKin: false,
      showEmergencyDetails: false,
      insurance: {
        name: "",
        policyNumber: "",
        number: "",
      },
      insuranceForm: "",
      nextOfKin: {
        name: "",
        relationship: "",
        number: "",
      },
      nextofKinForm: "",
      emergencyDetails: {
        email: "",
        number: "",
      },
      emergencyForm: "",
      modalData: { formsPerGroup: [], formsPerPerson: [] },
      api: VUE_APP_VT_DOCS,
      file: {},
    };
  },
  async mounted() {
    // Set the modal data
    this.setModalData();
  },
  methods: {
    show() {
      this.$refs["secure-docs-modal-ref"].show();
    },
    async setModalData() {
      if (!this.getUserData || !this.getUserData.bookno) {
        return;
      }
      if (this.info === "adhoc") {
        const res = await fetchAdhocDocuments(this.getUserData.bookno);
        if (res && res.data && res.data.length === 0) {
          return (this.showNoDocumentsMsg = true);
        }
        if (res && res.data) {
          this.modalData = res.data;
        } else {
          this.serviceDown = true;
        }
      } else {
        const res = await fetchSupplierProgress(
          this.getUserData.bookno,
          this.info.supplier
        );
        if (res && res.data && res.data.length === 0) {
          return (this.showNoDocumentsMsg = true);
        }
        if (res && res.data) {
          this.modalData = res.data;
        } else {
          this.serviceDown = true;
        }
      }
    },
    async openWebsite(formName, supplier) {
      if (supplier) {
        const res = await fetchSupplierWebURL(formName, supplier);
        if (res) {
          window.open(res.data, "_blank");
        }
      } else {
        const res = await fetchAdhocWebURL(formName);
        if (res) {
          window.open(res.data, "_blank");
        }
      }
    },
    async completeSupplierFilePerGroup(value, index) {
      const res = await completeSupplierFilePerGroupService(
        this.getUserData.bookno,
        value,
        this.info.supplier
      );
      if (res) {
        this.successGroup(index);
      } else {
        this.error();
      }
    },
    async completeSupplierFilePerPerson(
      value,
      client,
      parentIndex,
      childIndex
    ) {
      const res = await completeSupplierFilePerPersonService(
        this.getUserData.bookno,
        value,
        this.info.supplier,
        client
      );
      if (res) {
        this.successPerPerson(parentIndex, childIndex);
      } else {
        this.error();
      }
    },
    async completeAdhocFilePerGroup(value, index) {
      const res = completeAdhocFilePerGroupService(
        this.getUserData.bookno,
        formName
      );
      if (res) {
        this.successGroup(index);
      } else {
        this.error();
      }
    },
    async completeAdhocFilePerPerson(value, client, parentIndex, childIndex) {
      const res = completeAdhocFilePerPersonService(
        this.getUserData.bookno,
        value,
        client
      );
      if (res) {
        this.successPerPerson(parentIndex, childIndex);
      } else {
        this.error();
      }
    },
    async uploadSupplierFilePerGroup(file, formName, index) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadSupplierFilePerGroupService(
        this.getUserData.bookno,
        formName,
        this.modalData.supplier_ref,
        formData
      );
      if (res) {
        this.successGroup(index);
      } else {
        this.error();
      }
    },
    async uploadSupplierFilePerPerson(
      file,
      formName,
      client,
      parentIndex,
      childIndex
    ) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadSupplierFilePerPersonService(
        this.getUserData.bookno,
        formName,
        this.modalData.supplier_ref,
        client,
        formData
      );
      if (res) {
        this.successPerPerson(parentIndex, childIndex);
      } else {
        this.error();
      }
    },
    async uploadAdhocFilePerGroup(file, formName, index) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadAdhocFilePerGroupService(
        this.getUserData.bookno,
        formName,
        formData
      );
      if (res) {
        this.successGroup(index);
      } else {
        this.error();
      }
    },
    async uploadAdhocFilePerPerson(
      file,
      formName,
      client,
      parentIndex,
      childIndex
    ) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadAdhocFilePerPersonService(
        this.getUserData.bookno,
        formName,
        client,
        formData
      );
      if (res) {
        this.successPerPerson(parentIndex, childIndex);
      } else {
        this.error();
      }
    },
    successGroup(index) {
      this.showSuccess = true;
      this.timeout("showSuccess");
      this.modalData.formsPerGroup[index].completed = true;
    },
    successPerPerson(parentIndex, childIndex) {
      this.showSuccess = true;
      this.timeout("showSuccess");
      this.modalData.formsPerPerson[parentIndex].clients[
        childIndex
      ].completed = true;
    },
    error() {
      this.showError = true;
      this.timeout("showError");
    },
    timeout(action) {
      setTimeout(() => {
        this[action] = null;
      }, 10000);
    },
    uploadFile(file) {
      // TODO sort file upload
      this.$set(this.file, file, this.$refs[file][0].files[0]);
    },
    trimValue(value) {
      return value.split(" ").join("-");
    },
    openInsuranceForm(form, name) {
      this.showTable = false;
      this.insuranceForm = form;
      this.clientName = name;
      this.showInsurance = true;
    },
    async submitInsuranceForm() {
      this.$v.insurance.$touch();
      if (!this.$v.insurance.$invalid) {
        this.showTable = true;
        this.showInsurance = false;
        const res = await updateSecureDetails(
          this.getUserData.bookno,
          this.insuranceForm,
          this.modalData.supplier_ref,
          this.clientName,
          "insurance",
          this.insurance
        );
        if (res) {
          this.showSuccess = true;
          this.timeout("showSuccess");
          this.modalData.formsPerPerson.find((item) => {
            if (item.vt_value === this.insuranceForm) {
              item.clients.find((client) => {
                if (client.name === this.clientName) {
                  client.completed = true;
                }
              });
            }
          });
        } else {
          this.error();
        }
        this.insurance.name = "";
        this.insurance.policyNumber = "";
        this.insurance.number = "";
      }
    },
    openNextofKinForm(form, name) {
      this.showTable = false;
      this.nextofKinForm = form;
      this.clientName = name;
      this.showNextOfKin = true;
    },
    async submitNextofKinForm() {
      this.$v.nextOfKin.$touch();
      if (!this.$v.nextOfKin.$invalid) {
        this.showTable = true;
        this.showNextOfKin = false;
        const res = await updateSecureDetails(
          this.getUserData.bookno,
          this.nextofKinForm,
          this.modalData.supplier_ref,
          this.clientName,
          "nextofkin",
          this.nextOfKin
        );
        if (res) {
          this.showSuccess = true;
          this.timeout("showSuccess");
          this.modalData.formsPerPerson.find((item) => {
            if (item.vt_value === this.nextofKinForm) {
              item.clients.find((client) => {
                if (client.name === this.clientName) {
                  client.completed = true;
                }
              });
            }
          });
        } else {
          this.error();
        }
        this.nextOfKin.name = "";
        this.nextOfKin.relationship = "";
        this.nextOfKin.number = "";
      }
    },
    openEmergencyForm(form, name) {
      this.showTable = false;
      this.emergencyForm = form;
      this.clientName = name;
      this.showEmergencyDetails = true;
    },
    async submitEmergencyForm() {
      this.$v.emergencyDetails.$touch();
      if (!this.$v.emergencyDetails.$invalid) {
        this.showTable = true;
        this.showEmergencyDetails = false;
        const res = await updateSecureDetails(
          this.getUserData.bookno,
          this.emergencyForm,
          this.modalData.supplier_ref,
          this.clientName,
          "emergencydetails",
          this.emergencyDetails
        );
        if (res) {
          this.showSuccess = true;
          this.timeout("showSuccess");
          this.modalData.formsPerPerson.find((item) => {
            if (item.vt_value === this.emergencyForm) {
              item.clients.find((client) => {
                if (client.name === this.clientName) {
                  client.completed = true;
                }
              });
            }
          });
        } else {
          this.error();
        }
        this.emergencyDetails.email = "";
        this.emergencyDetails.number = "";
      }
    },
    returnFromForm() {
      this.showTable = true;
      this.showNextOfKin = false;
      this.showInsurance = false;
      this.showEmergencyDetails = false;
      this.insurance.name = "";
      this.insurance.policyNumber = "";
      this.insurance.number = "";
      this.nextOfKin.name = "";
      this.nextOfKin.relationship = "";
      this.nextOfKin.number = "";
      this.emergencyDetails.email = "";
      this.emergencyDetails.number = "";
    },
  },
  validations: {
    insurance: {
      name: {
        required: required,
      },
      policyNumber: {
        required: required,
      },
      number: {
        required: required,
      },
    },
    nextOfKin: {
      name: {
        required: required,
      },
      relationship: {
        required: required,
      },
      number: {
        required: required,
      },
    },
    emergencyDetails: {
      email: {
        required: required,
      },
      number: {
        required: required,
      },
    },
  },
};
</script>

<style scoped lang="scss">
a:hover {
  color: #fff;
  text-decoration: none;
}

label {
  margin-bottom: none !important;
  padding: 0.5rem 0;
}

.btn,
.vtd-btn {
  margin: 0;
}

.secure-doc-grid-1-row-1 {
  display: none;
}

.secure-doc-icon {
  display: flex;
  align-items: center;
  padding-bottom: 8px;

  h5 {
    margin-bottom: 0;
    margin-left: 5px;
    font-size: 16px;
  }
}

.icon-img {
  max-width: 32px;
}

.secure-doc-options {
  width: 100%;
}

.option-row {
  display: flex;
}

.option-btns {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
}

.deadline-date-span {
  display: inline-block;
  padding-top: 5px;
}

.btn-secure {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-secure-complete {
  border: 1px solid #007bff !important;
}

.btn-secure-upload {
  border: 1px solid #454545;
  cursor: pointer;

  label {
    cursor: pointer;
    margin: 0 !important;
  }
}

.hr-mobile-only {
  display: block;
}

.secure-deadline {
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-doc {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  h5 {
    margin-bottom: 0;
    font-size: 16px;
    margin-left: 20px;
  }
}

// Form styles
.help-block {
  background-color: #c23f3d;
  color: #fff;
  padding: 0.5rem;
}

.no-docs {
  background-color: #f5f5f5;
  border: none;
}

@media only screen and (min-width: 992px) {
  .secure-doc-grid-1-row-1 {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-items: center;
  }

  .secure-doc-grid-1-row-2 {
    display: grid;
    grid-template-columns: 30% 50% auto;
    align-items: center;
    margin-bottom: 10px;
  }

  .option-btns {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }

  .deadline-date-span {
    display: none;
  }

  .hr-mobile-only {
    display: none;
  }
}
</style>
